import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { BillingService } from '../services/billing.service';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import { HttpResponse } from '@angular/common/http';
import * as moment from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';

@Component({
  selector: 'app-billing-download',
  templateUrl: './billing-download.component.html',
  styleUrls: ['./billing-download.component.css'],
})
export class BillingDownloadComponent {
  dateFormat = 'date';
  currentYear: number;
  downloadForm: FormGroup;
  auxForm: FormGroup;
  displayValue: string = '';
  maxDate: Date = new Date();
  isLoading=false;
  isSearch=false;
  bills:any[]=[];
  constructor(private fb: FormBuilder, private billingService: BillingService) {
    this.currentYear = new Date().getFullYear();
    this.downloadForm = this.fb.group({
      date: '',
      provider: '',
      clientCode: '',
      cif: ['', Validators.required],
    });
    this.auxForm = this.fb.group({
      date: '',
      provider: '',
      clientCode: '',
      cif: ['', Validators.required],
    });
  }

  // onSubmit() {
  //   if (this.downloadForm.valid) {
  //     const { date, provider, clientCode, cif } = this.downloadForm.value;
  //     this.billingService.getBillingDownload(date, provider, clientCode, cif).subscribe({
  //       next: response => {
  //         saveAs(response.data, response.filename);
  //       },
  //       error: error => {
  //         console.error('Error downloading the file', error);
  //         Swal.fire({
  //           title: 'Error',
  //           text: 'Hubo un error al descargar las facturas. Por favor, inténtalo de nuevo.',
  //           icon: 'error',
  //           confirmButtonColor: '#d33',
  //         });
  //       }
  //     });
  //   } else {
  //     Swal.fire({
  //       title: 'Formulario Incompleto',
  //       text: 'Por favor, completa todos los campos requeridos.',
  //       icon: 'warning',
  //       confirmButtonColor: '#d33',
  //     });
  //   }
  // }

  onSubmit() {
    if (this.formValid()) {
      this.shearchBill()
    }else{
      Swal.fire({
        title: 'Formulario Incompleto',
        text: 'Por favor, completa todos los campos requeridos.',
        icon: 'warning',
        confirmButtonColor: '#d33',
      });
    }
  }

  separateDate(normalizedDate: any, datepicker?: any) {
    if (this.dateFormat !== 'year') {
      const day = this.padWithZero(normalizedDate.getDate());
      const month = this.padWithZero(normalizedDate.getMonth() + 1);
      const year = normalizedDate.getFullYear();
      console.log(this.dateFormat);
      switch (this.dateFormat) {
        case 'date':
          this.downloadForm.get('date')!.setValue(`${year}${month}${day}`);

          break;
        case 'month':
          this.downloadForm.get('date')!.setValue(`${year}${month}`);
          const date=new Date(year, parseInt(month) - 1, 1)
          /* let formattedDate = `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`; */
          /* console.log(formattedDate); */
          /* this.auxForm.get('date')!.setValue(formattedDate); */

          break;
      }
      datepicker.close();
    } else {
      this.downloadForm.get('date')!.setValue(`${this.auxForm.value.date}`);
    }
    console.log(this.auxForm.value);
    console.log(this.downloadForm.value);
  }
  readonly date = new FormControl(moment());

  setMonthAndYear(
    normalizedMonthAndYear: Date,
    datepicker: MatDatepicker<moment.Moment>
  ) {
    console.log(this.auxForm.get('date')!.value);
    const normalizedMoment = moment(normalizedMonthAndYear);
    const ctrlValue = this.date.value ? this.date.value.clone() : moment();
    ctrlValue.month(normalizedMoment.month());
    ctrlValue.year(normalizedMoment.year());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.separateDate(normalizedMonthAndYear, datepicker);
  }

  onDateFormatChange() {
    this.downloadForm.reset();
    /* this.auxForm.reset(); */
  }
  onDateSelected(event: any, datepicker?: any) {
    const selectedDate = event.value;
    this.separateDate(selectedDate, datepicker);
  }
  downloadBill(result:any) {
      const { fileName,date,clientCode } = result;
      debugger;
      this.billingService
        .getBillingDownload(fileName)
        .subscribe({
          next: (response: HttpResponse<Blob>) => {
            if (response.body) {
              const blob = new Blob([response.body], {
                type: 'application/pdf',
              });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `Factura_${date}_${clientCode}.pdf`;
              a.click();
              window.URL.revokeObjectURL(url);
            } else {
              console.error('Error downloading the file');
            }
          },
          error: (error) => {
            console.error('Error downloading the file', error);
            Swal.fire({
              title: 'Error',
              text: 'Hubo un error al descargar las facturas. Por favor, inténtalo de nuevo.',
              icon: 'error',
              confirmButtonColor: '#d33',
            });
          },
        });
    
  }
  shearchBill(){
    const { date} = this.downloadForm.value;
    const {clientCode, cif } = this.auxForm.value;
  
    this.billingService.getBillList(cif,date,clientCode).subscribe({
      next: response => {
       
        this.bills = response.results;
        console.log(this.bills);
        this.isSearch=true;
        this.isLoading=false;
      },
      error: error => {
        console.error('Error downloading the file', error);
        Swal.fire({
          title: 'Error',
          text: 'Hubo un error al descargar las facturas. Por favor, reintente nuevamente.',
          icon: 'error',
          confirmButtonColor: '#d33',
        });
      }
    })
   
  }
  formValid() {
    let valid = false;
    if (
      this.auxForm.get('cif')?.value
    ) {
      valid = true;
    }
    return valid;
  }
  private padWithZero(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }
}
